import * as React from "react";
import { AppState } from "src/redux/store";
import * as Stories from "src/redux/stories";
import { getProject } from "src/redux/projects/selectors";
import { connect } from "react-redux";
import DownloadableMedias from "src/components/DownloadableMedias";
import { toast } from "react-toastify";

interface Props {
  projectId: number;
}

function mapDispatchToProps(dispatch) {
  return {
    loadPrestations: (projectId: number) =>
      dispatch(Stories.fetchPrestationListOnce(projectId))
  };
}

const mapStateToProps = (state: AppState, props) => {
  return { project: getProject(state.projects, props) };
};

type PropsWithMapState = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps> &
  Props;

class DownloadableMediasContainer extends React.Component<PropsWithMapState> {
  async componentWillMount() {
    try {
      await this.props.loadPrestations(this.props.projectId);
    } catch (error) {
      toast.error("error load prestation");
    }
  }
  onIndexChange = (value: number) => {
    if (value === -1) {
      history.back();
    }
  };
  render() {
    if (!this.props.project) {
      return null;
    }

    return (
      <DownloadableMedias
        prestations={this.props.project.prestations}
        projectId={this.props.projectId}
        projectName={this.props.project.name}
      />
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DownloadableMediasContainer);



// WEBPACK FOOTER //
// ./src/containers/DownloadableMediasContainer.tsx